import { CERTA_API_URL } from 'config';
import { postWithResponse } from './fetch';
import { Guid } from 'types/guid';
import { TermsOfUseAcceptanceResponse } from 'types/api/terms-of-use/terms-of-use-acceptance-response';
import { TermsOfUseAcceptanceRequest } from 'types/api/terms-of-use/terms-of-use-acceptance-request';
import * as tokenService from 'services/token-service';
import * as tenantService from 'services/tenant-service';

async function createRequest(tenantId: Guid, termsIdName: 'optelTermsOfUseId' | 'nmvsTermsOfUseVersion', termsId: Guid,
  username: string): Promise<TermsOfUseAcceptanceRequest> {

  const acceptanceRequest: TermsOfUseAcceptanceRequest = {
    termsOfUseAcceptance: {
      [termsIdName]: termsId,
      tenantId,
      username: username
    }
  };

  return acceptanceRequest;
}

export async function acceptTerms(termsIdName: 'optelTermsOfUseId' | 'nmvsTermsOfUseVersion',
  termsId: Guid, username: string): Promise<TermsOfUseAcceptanceResponse> {

  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  const tenantId = await tenantService.getTenantId();
  const acceptanceRequest = await createRequest(tenantId, termsIdName, termsId, username);
  
  return await postWithResponse<TermsOfUseAcceptanceResponse>(
    `${CERTA_API_URL}/termsOfUse/acceptance`,
    acceptanceRequest,
    token,
    tenantId
  );
}


// WEBPACK FOOTER //
// ./src/api/terms-of-use-api.ts